import React from "react";
import { Button, Select, Input, InputNumber, Space, Divider, Typography, Popover } from "antd";
import { PlusOutlined, SaveOutlined, DownloadOutlined, ArrowLeftOutlined, BorderOutlined } from "@ant-design/icons";
import { ACCENT_DARK } from "../constants/quotationConstants";

const { Text } = Typography;

export default function EditorToolbar({
  onBackToGallery,
  quotationName,
  onQuotationNameChange,
  products,
  productsLoading,
  productsError,
  productId,
  onProductIdChange,
  layoutsLoading,
  onAddElement,
  onSaveClick,
  saving,
  onDownloadPDF,
  exporting,
  margin,
  onMarginChange,
}) {
  const marginField = (label, key) => (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 10, marginBottom: 6 }}>
      <span style={{ fontSize: 12.5, color: "#6B7686" }}>{label}</span>
      <InputNumber
        size="small"
        min={0}
        max={300}
        value={margin[key]}
        style={{ width: 80 }}
        onChange={(v) => onMarginChange({ ...margin, [key]: v ?? 0 })}
      />
    </div>
  );

  return (
    <div className="no-print" style={{ padding: "12px 18px", background: "#fff", borderBottom: "1px solid #E4E8EE", flexShrink: 0 }}>
      <Space wrap size={10}>
        <Button icon={<ArrowLeftOutlined />} onClick={onBackToGallery}>
        
        </Button>

        <Input placeholder="Quotation name" value={quotationName} onChange={(e) => onQuotationNameChange(e.target.value)} style={{ width: 170 }} />

        <Select
          mode="multiple"
          value={productId}
          placeholder={productsLoading ? "Loading products…" : "Select product(s)"}
          loading={productsLoading}
          onChange={onProductIdChange}
          allowClear
          maxTagCount={2}
          style={{ minWidth: 200, maxWidth: 280 }}
          options={products.map((p) => ({ value: p.productId, label: p.productName }))}
        />

        {productsError && (
          <Text type="danger" style={{ fontSize: 11.5 }}>
            {productsError}
          </Text>
        )}
        {layoutsLoading && (
          <Text style={{ fontSize: 11.5, color: "#8A94A3" }}>
            Loading layouts…
          </Text>
        )}

        <Divider type="vertical" style={{ height: 24, margin: 0 }} />

        <Button icon={<PlusOutlined />} onClick={() => onAddElement("heading")}>
          Heading
        </Button>
        <Button icon={<PlusOutlined />} onClick={() => onAddElement("text")}>
          Text
        </Button>
        <Button icon={<PlusOutlined />} onClick={() => onAddElement("table")}>
          Table
        </Button>
        <Button icon={<PlusOutlined />} onClick={() => onAddElement("line")}>
          Line
        </Button>
        <Button icon={<PlusOutlined />} onClick={() => onAddElement("rect")}>
          Box
        </Button>
        <Button icon={<PlusOutlined />} onClick={() => onAddElement("image")}>
          Image
        </Button>

        <Popover
          trigger="click"
          title="Page margins (px)"
          content={
            <div style={{ width: 190 }}>
              {marginField("Top", "top")}
              {marginField("Right", "right")}
              {marginField("Bottom", "bottom")}
              {marginField("Left", "left")}
              <Button
                size="small"
                block
                onClick={() => onMarginChange({ top: 0, right: 0, bottom: 0, left: 0 })}
              >
                No margin
              </Button>
            </div>
          }
        >
          <Button icon={<BorderOutlined />}>Margins</Button>
        </Popover>

        <Button type="primary" icon={<SaveOutlined />} onClick={onSaveClick} loading={saving} title="Save this layout to server">
          Save
        </Button>
        <Button icon={<DownloadOutlined />} onClick={onDownloadPDF} loading={exporting} title="Directly downloads a PDF file">
          Download PDF
        </Button>
      </Space>
    </div>
  );
}